import { render, staticRenderFns } from "./day.vue?vue&type=template&id=010ad79e&scoped=true&"
import script from "./day.vue?vue&type=script&lang=js&"
export * from "./day.vue?vue&type=script&lang=js&"
import style0 from "./day.vue?vue&type=style&index=0&id=010ad79e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ad79e",
  null
  
)

export default component.exports